export default "__VITE_ASSET__351b3f49__"